// @flow

import * as React from 'react';

import type { ChangeOrderTypeProps } from '../../../context/orderContent.context';
import type { GridItem } from '../../../types'

type Props = {
  condition: boolean,
  updater: ChangeOrderTypeProps => mixed,
  collection: Array<GridItem>,
};

export default class LocalOrderItemsUpdater extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    if (this.props.condition) {
      this.props.updater({
        collection: this.props.collection,
        action: 'update'
      });
    }
  }

  render() {
    return null;
  }
}
